import { useCallback, useContext, useEffect, useState } from "react";
import ToastContext from "../../context/toastProvider";
import Loading from "../atoms/loading";
import Button from "../atoms/button";
import { getStaff, getGroups, updateRoles } from "./functions";
import StaffList from "./staffList";
import ManageRolesModal from "./manageRolesModal";
import PromoteModal from "./promoteModal";
import GroupsPanel from "./groupsPanel";

const AccessPage = ({ user }) => {
    const { goodToast, badToast } = useContext(ToastContext);

    const [tab, setTab] = useState("staff");
    const [staff, setStaff] = useState([]);
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState(null);
    const [promoteOpen, setPromoteOpen] = useState(false);

    const refresh = useCallback(async () => {
        setLoading(true);
        const [staffData, groupsData] = await Promise.all([
            getStaff(user.token),
            getGroups(user.token),
        ]);
        setLoading(false);
        if (staffData.type === "error") {
            badToast(staffData.message);
            return;
        }
        setStaff(staffData.data || []);
        setGroups(groupsData.type === "success" ? groupsData.data || [] : []);
    }, [user.token, badToast]);

    useEffect(() => {
        refresh();
        // eslint-disable-next-line
    }, []);

    const applyRoles = async (target, desired) => {
        const data = await updateRoles(user.token, target._id, desired);
        if (data.type === "error") {
            badToast(data.message);
            return;
        }
        goodToast("Acesso atualizado");
        setSelected(null);
        setPromoteOpen(false);
        refresh();
    };

    const tabClass = (active) =>
        `px-4 py-2 border-b-2 ${active ? "border-[#d59106] text-[#d59106]" : "border-transparent hover:text-[#d59106]"}`;

    return (
        <div className="p-6">
            <div className="mb-4 flex items-center justify-between">
                <h2 className="text-xl">Acessos</h2>
                {tab === "staff" ? (
                    <Button classes="bg-[#d59106] hover:bg-orange-500" click={() => setPromoteOpen(true)}>
                        Adicionar admin
                    </Button>
                ) : null}
            </div>
            <div className="mb-6 flex gap-2 border-b border-[#b47c06]/40">
                <button type="button" className={tabClass(tab === "staff")} onClick={() => setTab("staff")}>
                    Administradores
                </button>
                <button type="button" className={tabClass(tab === "groups")} onClick={() => setTab("groups")}>
                    Grupos
                </button>
            </div>

            {loading ? <Loading /> : tab === "staff" ? (
                <StaffList staff={staff} onSelect={setSelected} />
            ) : (
                <GroupsPanel user={user} staff={staff} groups={groups} onChanged={refresh} />
            )}

            <ManageRolesModal
                open={Boolean(selected)}
                staffUser={selected}
                currentUser={user}
                onClose={() => setSelected(null)}
                onSave={applyRoles}
            />
            <PromoteModal
                open={promoteOpen}
                user={user}
                onClose={() => setPromoteOpen(false)}
                onPromote={applyRoles}
            />
        </div>
    );
};

export default AccessPage;
